export default {
  Orders: 'Orders',
  ExportOrders: 'ExportOrders',
  OrderConfirmation: 'OrderConfirmation',
  OrderDetailConfirmation: 'OrderDetailConfirmation',
  OrderDetailConfirmMove: 'OrderDetailConfirmMove',
  CopyOrders: 'CopyOrders',
  OrderDetails: 'OrderDetails',
  ImportOrder: 'ImportOrder',
  OrdersWithSearch: 'OrdersWithSearch',
  OrdersWithView: 'OrdersWithView',
  OrdersPlaceholder: 'OrdersPlaceholder',
  OrderPricing: 'OrderPricing',
  OrderDetailsPlaceholder: 'OrderDetailsPlaceholder',
  AddProductToOrder: 'AddProductToOrder',
  EditCustomerInformation: 'EditCustomerInformation',
  EditShippingDetails: 'EditShippingDetails',
  EditGiftMessage: 'EditGiftMessage',
  SplitOrder: 'SplitOrder',
  ReturnLabel: 'ReturnLabel',
  GenerateReturnLabel: 'GenerateReturnLabel',
  SubscribeToOrder: 'SubscribeToOrder',
  UnsubscribeToOrder: 'UnsubscribeToOrder'
}
